// extracted by mini-css-extract-plugin
export default {"form":"form--DLzZk","submit":"submit--BZxvS"};